export const addressKeys = ['Address1', 'Address2', 'Address3'];
